import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import useModalStore from "../StatesStore/ModalStore";
import handleUnfollowBrand from "../hooks/brand/unfollowBrand";
import handleUnfollowUser from "../hooks/user/unfollowUser";
import { toast } from "react-toastify";
import { toastOptions } from "../lib/toastOptions";
import useNotification from "../hooks/useNotification";
import useFollowUser from "../hooks/useFollowUser";

function ConfirmUnfollow() {
  const { title, data, closeModal } = useModalStore();
  const { deleteNotification } = useNotification();
  const { unfollowUser } = useFollowUser(data.UID, data.friendUID);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const BrandUnfollow = async () => {
    toast.success("Brand unfollowed successfully", toastOptions);
    closeModal();
    data.FollowButton(false);
    data.SetFollowerCount((prev) => prev - 1);
    await handleUnfollowBrand(data.UID, data.brandName);
  };

  const UserUnfollow = async () => {
    await unfollowUser();
    console.log(
      "user unfollow data.UID, data.friendUID",
      data.UID,
      data.friendUID
    );
    data.FollowButton(false);
    // toast.success("User unfollowed successfully", toastOptions);
    closeModal();
    await deleteNotification({
      userId: data.friendUID,
      id: data.UID,
      type: "followed",
      by: "user",
    });
  };

  return (
    <Modal show centered onHide={closeModal}>
      <Modal.Body style={{ padding: isSmallScreen ? "1rem" : "2rem" }}>
        <div className="d-flex flex-column">
          <div className="d-flex w-100 justify-content-between">
            <div className="h4">
              Unfollow {title === "brand" ? "Brand" : "User"}
            </div>
            <button
              type="button"
              style={{
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                width: "27px",
                height: "27px",
                background: "#FFFFFF",
                border: "1px solid #FF3B30",
                boxShadow: "1px 1px 5px rgba(30, 30, 30, 0.14)",
                borderRadius: "25px",
                flex: "none",
                order: "1",
                flexGrow: "0",
              }}
              onClick={closeModal}
            >
              <svg
                style={{ width: "11px" }}
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 1L1 13M1 1L13 13"
                  stroke="#FF3B30"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
          <p>
            Are you sure you want to unfollow{" "}
            <span style={{ fontWeight: 600 }}>{data.displayName}</span> ? This
            action cannot be undone.
          </p>
        </div>
        <div className="d-flex flex-column gap-2 w-100 mt-3">
          <Button
            style={{
              borderRadius: "10px",
              backgroundColor: "#005FDA",
              color: "white",
            }}
            onClick={() =>
              title === "brand" ? BrandUnfollow() : UserUnfollow()
            }
          >
            Unfollow
          </Button>
          <Button
            style={{
              border: "1px solid #005FDA",
              backgroundColor: "white",
              color: "#005FDA",
            }}
            onClick={closeModal}
          >
            Cancel
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ConfirmUnfollow;
